import styled, { css } from 'styled-components';
import { Typography } from 'src/typography';

export const ScrollableStepContent = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 0;
  overflow-y: auto;
`;

export const SubQuestionText = styled(Typography.Body).attrs({ size: 'small' })`
  color: var(--dcm-good-canna-subquestion-text-color, #6b7280);
  text-align: center;
  margin-top: -8px;
  margin-bottom: 8px;
`;

export const ConditionGrid = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 10px;
  width: 100%;
`;

export const ConditionTile = styled.div<{ selected?: boolean }>`
  ${({ selected }) => css`
    flex-basis: calc(50% - 5px);
    text-align: center;
    padding: 16px;
    border-radius: var(--dcm-good-canna-tile-border-radius, 12px);
    cursor: pointer;
    border: 1px solid var(--dcm-good-canna-tile-border-color, ${selected ? '#1a73e8' : '#d0d5dd'});
    background-color: var(--dcm-good-canna-tile-bg-color, ${selected ? '#eaf1fd' : '#ffffff'});
  `}
`;

// Stacked full-width instead of CustomRadio's 2-column grid, which is built
// for 2 options and leaves a 3rd one off-center.
export const FollowUpQuestionText = styled(Typography.Body).attrs({ size: 'medium' })`
  color: var(--dcm-good-canna-question-text-color, #171a1c);
  margin-bottom: 4px;
  font-weight: 500;
`;

export const FollowUpOptionsGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;
  margin-bottom: 20px;
`;

export const FollowUpOptionLabel = styled.div<{ selected?: boolean; hasError?: boolean }>`
  ${({ selected, hasError }) => {
    const defaultBorderColor = hasError ? '#d92d20' : '#d0d5dd';

    return css`
      width: 100%;
      text-align: left;
      padding: 12px 16px;
      border-radius: var(--dcm-good-canna-option-border-radius, 12px);
      cursor: pointer;
      border: 1px solid var(--dcm-good-canna-option-border-color, ${selected ? '#1a73e8' : defaultBorderColor});
      background-color: var(--dcm-good-canna-option-bg-color, ${selected ? '#eaf1fd' : '#ffffff'});
    `;
  }}
`;

export const ReviewSummary = styled.div`
  width: 100%;
  padding: 16px;
  border-radius: var(--dcm-good-canna-review-border-radius, 12px);
  border: 1px solid var(--dcm-good-canna-review-border-color, #d0d5dd);
  background-color: var(--dcm-good-canna-review-bg-color, #f9fafb);
  margin-bottom: 16px;
`;

export const ReviewRow = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 12px;

  &:last-child {
    margin-bottom: 0;
  }
`;
